import { useEffect, useRef } from 'react';

/**
 * Fires `handler` when the user presses Escape. `handler` may change between
 * renders; the listener itself is only attached/detached when `enabled` flips,
 * preventing effect churn in parents that don't stabilise the callback.
 */
export function useEscapeKey(handler: () => void, enabled = true): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        handlerRef.current();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [enabled]);
}
